import { useSession } from 'next-auth/react';
import { useRouter } from 'next/router';
import { useNavigation } from './useNavigation';

export default function useProtectClient() {
    const session = useSession();

    const { system } = useNavigation();

    const router = useRouter();

    return function protect(callbackUrl?: string, notAuthorizedMessage?: string) {
        if (session?.status !== 'authenticated') {
            const encodedUri = encodeURIComponent(callbackUrl ?? window.location.href);
            const formattedNotAuthorized = notAuthorizedMessage
                ? `&notAuthorizedMessage=${encodeURIComponent(notAuthorizedMessage ?? '')}`
                : '';

            const callback = [
                encodedUri,
                formattedNotAuthorized,
            ].join();

            router.push(system.userLoginCallback(callback));

            return false;
        }
        if (session?.data?.role === 'guest') {
            router.push(system.userRegister);

            return false;
        }

        return true;
    };
}
